import combineHandlers from '@/utils/combine-handlers';
import {
  type ChangeEventHandler,
  type ForwardedRef,
  useEffect,
  useRef,
  useState,
} from 'react';
import { mergeRefs } from 'react-merge-refs';

interface Props {
  checked?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

export const useInternalCheckedState = (
  { checked, onChange }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) => {
  const internalRef = useRef<HTMLInputElement>(null);

  const [isChecked, setIsChecked] = useState(checked ?? false);

  useEffect(() => {
    setIsChecked(checked ?? false);
  }, [checked]);

  const changeHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    // Only if input is uncontrolled
    if (checked === undefined) {
      setIsChecked(e.target.checked);
    }
  };

  return [
    isChecked,
    mergeRefs([ref, internalRef]),
    combineHandlers(changeHandler, onChange),
  ] as const;
};
